/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mHead.vue?vue&type=template&id=1be52fdb"
import script from "./mHead.vue?vue&type=script&lang=js"
export * from "./mHead.vue?vue&type=script&lang=js"
import style0 from "./mHead.vue?vue&type=style&index=0&id=1be52fdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports